import React from 'react';
import PropTypes from 'prop-types';

function encodeParams(params) {
  return Object.keys(params)
    .map(key => [key, params[key]].map(encodeURIComponent).join('='))
    .join('&');
}

const ContentfulImage = ({ src, alt, type, className = '' }) => {
  let srcSet;
  let sizes;
  let widths;
  let imageParams;

  switch (type) {
    case 'grid':
      sizes = '(max-width: 599px) 100vw, 50vw';
      imageParams = {
        w: 900,
        fit: 'fill',
        fl: 'progressive',
        h: 338,
      };
      widths = [300, 400, 500, 600, 700, 800, 900, 1000, 1100];
      srcSet = [];
      widths.forEach((width, i) => {
        const srcParams = {
          ...imageParams,
          w: widths[i],
          h: Math.round(widths[i] * (9 / 16)),
        };
        srcSet.push(`${src}?${encodeParams(srcParams)} ${width}w`);
      });
      srcSet = srcSet.join(', ');
      break;

    case 'hero':
      sizes = '(max-width: 1380px) 100vw, 1380px';
      imageParams = {
        h: 720,
        w: 1920,
        fit: 'fill',
        fl: 'progressive',
      };
      widths = [1366, 1600, 1920, 2000, 2300];
      srcSet = [];
      widths.forEach(width => {
        const srcParams = {
          ...imageParams,
          w: width,
          h: Math.round(width * (720 / 1920)),
        };
        srcSet.push(`${src}?${encodeParams(srcParams)} ${width}w`);
      });
      srcSet = srcSet.join(', ');
      break;
    case 'featured':
      sizes = '(max-width: 767px) 100vw, 70vw';
      imageParams = {
        w: 1600,
        h: 1063, // keeps the 480x319 (~1.504:1) crop, just higher-res
        fit: 'fill',
        fl: 'progressive',
      };
      widths = [768, 1024, 1366, 1600, 1920];
      srcSet = [];
      widths.forEach(width => {
        const srcParams = {
          ...imageParams,
          w: width,
          h: Math.round(width * (1063 / 1600)),
        };
        srcSet.push(`${src}?${encodeParams(srcParams)} ${width}w`);
      });
      srcSet = srcSet.join(', ');
      break;
    case 'blogProduct':
      sizes = '(max-width: 650px) 100vw, 650px';
      imageParams = {
        w: 900,
        fit: 'fill',
        fl: 'progressive',
      };
      widths = [300, 400, 500, 600, 700, 800, 900, 1000, 1100];
      srcSet = [];
      widths.forEach((width, i) => {
        const srcParams = {
          ...imageParams,
          w: widths[i],
        };
        srcSet.push(`${src}?${encodeParams(srcParams)} ${width}w`);
      });
      srcSet = srcSet.join(', ');
      break;
    default:
  }
  const publicSrc = `${src}?${encodeParams(imageParams)}`;
  // Above-the-fold blog images load eagerly; lists/embeds lazy-load.
  const loading = type === 'hero' || type === 'featured' ? 'eager' : 'lazy';
  return (
    <img
      src={publicSrc}
      alt={alt}
      className={className}
      srcSet={srcSet}
      sizes={sizes}
      loading={loading}
    />
  );
};

ContentfulImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
};

export default ContentfulImage;
